<template>
    <div class="content-container">
        <div class="content h-auto">
            <div class="container">
                <div class="row">
<!--                <div class="row" v-if="reference">-->

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>{{$t('bp.BookingComplete.title')}}</h1>
                        </div>
                    </div>

                    <template v-if="reference">

                        <!-- Booking Details -->
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <h4>
                                      <template v-if="bookingIsDropOff">{{$t('bp.BookingComplete.repairType.bookingIsDropOff')}}</template>
                                      <template v-else-if="bookingIsMailIn">{{$t('bp.BookingComplete.repairType.bookingIsMailIn')}}</template>
                                      <template v-else>{{$t('bp.BookingComplete.repairType')}}</template>
                                    </h4>
                                </div>
                                <div class="card-body pb-2">
                                    <dl>
                                        <dt>{{ $t('bp.ManageBooking.orderReference') }}</dt>
                                        <dd>{{ booking.order_ref }}</dd>
                                    </dl>
                                    <dl v-if="!bookingIsMailIn">
                                        <dt>{{$t('bp.SelectLocation.title')}}</dt>
                                        <dd>{{ parseAddressToString(booking.address) }}</dd>
                                    </dl>
                                    <dl v-if="!bookingIsMailIn">
                                        <dt>{{$t('bp.BookingComplete.repairDate')}}</dt>
                                        <dd>{{ booking.full_date }}</dd>
                                    </dl>
                                    <dl v-if="!bookingIsDropOff && !bookingIsMailIn">
                                        <dt>{{$t('bp.BookingComplete.timeslot')}}</dt>
                                        <dd>{{$t('bp.BookingComplete.timeslot.text')}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>{{ isApplianceRepair ? $t('bp.BookingComplete.appliance') : $t('bp.BookingComplete.devices') }}</dt>
                                        <dd v-for="device in devices" :key="device.key">
                                            {{ device.device.title }}
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>{{$t('bp.BookingComplete.billingAddress')}}</dt>
                                        <dd>{{ parseAddressToString(booking.billing_address) }}</dd>
                                    </dl>
                                    <dl v-if="!booking.is_promotion_event && (!inWarrantyStatus || warrantyRepairChargeable)">
                                        <dt>{{$t('bp.total')}}</dt>
                                        <dd><span v-html="currencySymbol" v-if="countryCodeSetting !== 'DE'"></span>{{ orderTotal }} <span v-html="currencySymbol" v-if="countryCodeSetting === 'DE'"></span></dd>
                                    </dl>
                                    <dl v-if="booking.is_promotion_event">
                                        <dt>{{$t('bp.BookingComplete.promoEvent')}}</dt>
                                        <dd>{{ booking.promotion_event.name }}</dd>
                                    </dl>
                                </div>
                            </div>
                        </div>

                        <!-- IMEI Request -->
                        <div class="col-12" v-if="hasPhoneOrValidTablet && !inWarrantyStatus && !bookingIsMailIn && !isApplianceRepair">
                            <div class="card">
                                <div class="card-header">
                                    <h4>{{$t('bp.BookingComplete.imei.title')}}</h4>
                                </div>
                                <div class="card-body pb-2 pt-0">
                                    <small class="cursor-pointer form-text text-underline mb-5" v-b-modal.imei-modal>{{$t('bp.BookingComplete.imei.helperText')}}</small>
                                    <imei-item
                                        v-for="(device, key) in devices"
                                        :key="key"
                                        :device="device"
                                    ></imei-item>
                                    <div class="alert alert-info mt-4" v-if="carrierDetails.hasCallOutCharge">
                                        <div class="alert-content text-sm">
                                           {{$t('bp.BookingComplete.imei.info.p1')}}<strong><span v-html="currencySymbol" v-if="countryCodeSetting !== 'DE'"></span>{{ carrierDetails.callOutCharge }} <span v-html="currencySymbol" v-if="countryCodeSetting === 'DE'"></span> {{$t('bp.BookingComplete.imei.info.p2')}} </strong>{{$t('bp.BookingComplete.imei.info.p3')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Important Information -->
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <h4>{{$t('bp.BookingComplete.information.title')}}</h4>
                                </div>
                                <div class="card-body pb-2">
                                    <p>
                                      {{$t('bp.BookingComplete.information.text.p1')}}
                                    </p>
                                    <template v-if="!bookingIsDropOff && !bookingIsMailIn">
                                        <p>
                                          {{$t('bp.BookingComplete.information.text.p2')}}
                                        </p>
                                        <p>
                                          {{$t('bp.BookingComplete.information.text.p3')}}
                                        </p>
                                        <p v-if="carrierDetails.hasCallOutCharge">

                                          {{$t('bp.BookingComplete.information.text.p4.p1')}} <span v-html="currencySymbol" v-if="countryCodeSetting !== 'DE'"></span>{{ carrierDetails.callOutCharge }} <span v-html="currencySymbol" v-if="countryCodeSetting === 'DE'"></span> {{$t('bp.BookingComplete.information.text.p4.p2')}}
                                        </p>
                                    </template>
                                    <p v-if="!bookingIsMailIn">
                                      {{$t('bp.BookingComplete.information.text.p5')}}
                                    </p>
                                    <p v-if="!isApplianceRepair">
                                      {{$t('bp.BookingComplete.information.text.p6')}}
                                    </p>
                                    <p class="text-center">
                                        <button class="btn btn-success btn-lg" @click="startNewBooking">{{$t('bp.BookingComplete.newBookingButton')}}</button>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Contact -->
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <h4>{{$t('bp.BookingComplete.contact.title')}}</h4>
                                </div>
                                <div class="card-body pb-2">
                                    <p v-if="carrierDetails.phone !== '-'">
                                      {{$t('bp.BookingComplete.contact.telephone')}}{{ carrierDetails.phone }}
                                    </p>
                                    <p>
                                        Email: <a :href="`mailto:`+carrierDetails.email">{{ carrierDetails.email }}</a>
                                    </p>
                                    <p>
                                        Web: <a :href="carrierDetails.web" target="_blank">{{ carrierDetails.formattedWeb }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

                <!-- IMEI Instruction Modal -->
                <imei-modal></imei-modal>

            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

    export default {
        name: "BookingComplete",

        mounted() {
            // this.checkCanBeOnPage();
            this.retrieveBooking().then(() => {
                if (this.$gtag !== undefined) {
                    this.$gtag.purchase(this.analyticsEcommerceData)
                }
            });
        },

        computed: {
            ...mapGetters([
                "analyticsEcommerceData",
                "booking",
                "carrierDetails",
                "cartTotal",
                "devices",
                "inWarrantyStatus",
                "parseAddressToString",
                "reference",
                "repairLocationOption",
                "warrantyRepairChargeable",
                "warrantyRepairCharge",
                "bookingIsDropOff",
                "bookingIsMailIn",
                "currencySymbol",
                "countryCodeSetting",
                "isApplianceRepair"
            ]),

            carrierName() {
                if (this.carrierDetails.name === "tesco-mobile") {
                    return "Likewize";
                }

                return this.carrierDetails.formattedName;
            },

            hasPhoneOrValidTablet() {
                if (this.devices.length === 0) {
                    return false;
                }

                let hasPhoneOrValidTablet = false;

                for (let i in this.devices) {
                    if (this.devices[i].device.device_type === "phone") {
                        hasPhoneOrValidTablet = true;
                    }
                    // if (this.devices.device_type === "tablet" && this.devices.device_make === "samsung") {
                    //     hasPhoneOrValidTablet = true;
                    // }
                }
                return hasPhoneOrValidTablet;
            },

            locationType() {
                if (this.bookingIsDropOff) {
                    return "In-store drop-off";
                } else if (this.bookingIsMailIn) {
                    return "Mail-in repair";
                }
                return 'Doorstep repair';
            },

            orderTotal() {
                if (this.warrantyRepairChargeable) {
                    return this.warrantyRepairCharge;
                }
                return this.cartTotal;
            }
        },

        methods: {
            ...mapActions([
                "clearBooking",
                "retrieveBooking"
            ]),

            checkCanBeOnPage() {
                if (this.booking.checkout_status !== "SUCCESS") {
                    this.$router.push({name: 'checkout'});
                }
            },

            startNewBooking() {
                this.clearBooking().then(() => {
                    this.$router.push({name: 'booking'})
                });
            }
        }
    }
</script>

<style scoped>

</style>